import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { destinations10 } from "../../../data/desinations";
import {useEffect, useState} from "react";
import {slugify} from "@/utils/slugify.js";

const TopDestinations = () => {
    const [trips, setTrips] = useState([]);
    useEffect(() => {
        fetch('https://api.tripsi.pl/api/trips/destinations/all')
            .then(response => response.json())
            .then(data => setTrips(data.content));
    }, []);

    function getPricePerDay(item) {
        return <> {Math.round(item.pricePerDay)}</>;
    }

    return (
    <>
      <Swiper
        spaceBetween={30}
        className="overflow-visible"
        modules={[Navigation]}
        navigation={{
          nextEl: ".js-top-desti-next_active",
          prevEl: ".js-top-desti-prev_active",
        }}
        breakpoints={{
          500: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 22,
          },
          1024: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 5,
          },
        }}
      >
        {trips.map((item) => (
          <SwiperSlide key={item.id}>
              {/* Links to the destination's clean SEO hub (current best offers + intro + link
                  into the full search), not straight to one frozen trip - see App.jsx's
                  /kierunek/:destinationSlug route. */}
              <Link
                  to={"/kierunek/" + slugify(item.destination?.name)}
                  className="citiesCard -type-3 d-block h-full rounded-4 "
              >
                  <div className="citiesCard__image ratio ratio-1:1">
                      <img className="col-12 js-lazy" src={item.destination.photoUrl} alt="image" loading="lazy" decoding="async"/>
                  </div>
                  <div className="citiesCard__content px-30 py-30">
                      {/* h3, not h4 - directly follows the page's h2 "Sprawdź nasze
                          destynacje" title, so h4 would skip a level. */}
                      <h3 className="text-26 fw-600 text-white text-capitalize">
                          {item.destination.name}
                      </h3>
                      <div className="text-15 text-white">
                          {/*{item.numberOfProperties} properties*/}
                          od {getPricePerDay(item)} zł/dzień
                      </div>
                  </div>
              </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Start naviation button for next prev slide */}
      <button className="section-slider-nav -prev flex-center bg-white text-dark-1 size-40 rounded-full shadow-1 sm:d-none  js-top-desti-prev_active" aria-label="Poprzednie destynacje">
        <i className="icon icon-chevron-left text-12" />
      </button>
      <button className="section-slider-nav -next flex-center bg-white text-dark-1 size-40 rounded-full shadow-1 sm:d-none  js-top-desti-next_active" aria-label="Następne destynacje">
        <i className="icon icon-chevron-right text-12" />
      </button>
      {/* End navigation button for next prev  slide */}
    </>
  );
};

export default TopDestinations;
